import { render, staticRenderFns } from "./UserButtonLoader.vue?vue&type=template&id=0170bc8d&scoped=true&"
import script from "./UserButtonLoader.vue?vue&type=script&lang=js&"
export * from "./UserButtonLoader.vue?vue&type=script&lang=js&"
import style0 from "./UserButtonLoader.vue?vue&type=style&index=0&id=0170bc8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170bc8d",
  null
  
)

export default component.exports